<template>
  <div id="register-infomation">
    <div class="tab-header">
      <v-row>
        <v-col sm="6">
          <label class="tab-title">{{ $t("HOTEL_REGISTER_INFO") }}</label>
        </v-col>
        <v-col sm="6" class="text-right">
          <button class="btn btn-save" @click="save">{{ $t("SAVE") }}</button>
        </v-col>
      </v-row>
    </div>
    <div class="tab-content">
      <v-row>
        <v-col sm="6" class="py-2">
          <label class="label-input">{{ $t("HOTEL_CODE") }}</label>
          <input-text type="text" disabled :model.sync="data.id" />
        </v-col>
        <v-col sm="6" class="py-2">
          <label class="label-input">Website</label>
          <input-text type="text" :model.sync="data.website" />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="6" class="py-2">
          <v-row>
            <v-col sm="12" class="pt-0 pb-2">
              <label class="label-input">{{ $t("STAR_RATING") }} *</label>
              <select-text :items="select.stars" :id.sync="data.star" />
            </v-col>
            <v-col sm="12" class="pt-2 pb-0">
              <label class="label-input">{{ $t("CONTACT_PHONE") }} *</label>
              <input-text
                :regex="REGEX_PHONE"
                :model.sync="data.telephone"
                :error.sync="errors.telephone.error"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="4" class="py-2">
          <v-row>
            <v-col sm="12" class="cursor py-0">
              <label class="label-input">{{ $t("HOTEL_LOGO") }}</label>
              <div
                v-if="data.logo && !data.logo.id"
                id="upload-controller"
                class="relative"
                @click="upload"
              >
                <div class="container">
                  <!--UPLOAD-->
                  <form enctype="multipart/form-data" novalidate>
                    <div class="dropbox">
                      <span class="icon-upload"></span>
                    </div>
                  </form>
                </div>
              </div>
              <div v-if="data.logo && data.logo.id" class="relative logo-box">
                <img :src="data.logo.url" alt width="100%" />
                <div class="mask">
                  <span class="icon-upload" @click="upload"></span>
                  <span class="icon-delete-ic" @click="data.logo = {}; data.logoId = null" />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="6" class="py-2 mb-4">
          <label class="label-input">{{ $t("HOTEL_TYPE") }} *</label>
          <select-text :items="select.hotelTypes" :id.sync="data.hotelType" />
        </v-col>
      </v-row>
      <v-divider class="mb-3"></v-divider>
      <v-row>
        <v-col sm="6" class="py-2">
          <label class="label-input">{{ $t("COUNTRY") }} *</label>
          <!-- <select-text
            :items="select.countries"
            :id.sync="country"
            :error.sync="errors.countryId.error"
          />-->
          <vue-single-select
            placeholder
            v-model="country"
            :options="select.countries"
            option-label="value"
            :required="errors.countryId.error"
            :classes="{
              input: 'search-input',
              wrapper: 'single-select-wrapper',
              icons: 'icons glyphicon',
              required: 'required'
            }"
          ></vue-single-select>
        </v-col>
        <v-col sm="6" class="py-2">
          <label class="label-input">{{ $t("CITY") }} *</label>
          <!-- <select-text :items="select.cities" :id.sync="city" :error="errors.cityId.error" /> -->
          <vue-single-select
            placeholder
            v-model="city"
            :options="select.cities"
            option-label="value"
            :required="errors.cityId.error"
            :classes="{
              input: 'search-input',
              wrapper: 'single-select-wrapper',
              icons: 'icons glyphicon',
              required: 'required'
            }"
          ></vue-single-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="6" class="py-2 mb-4">
          <label class="label-input">{{ $t("DISTRICT") }} *</label>
          <!-- <select-text :items="select.districts" :id.sync="data.locId" :error="errors.locId.error" /> -->
          <vue-single-select
            placeholder
            v-model="district"
            :options="select.districts"
            option-label="value"
            :required="errors.locId.error"
            :classes="{
              input: 'search-input',
              wrapper: 'single-select-wrapper',
              icons: 'icons glyphicon',
              required: 'required'
            }"
          ></vue-single-select>
        </v-col>
        <v-col sm="6" class="py-2 mb-4">
          <label class="label-input">{{ $t("WARD") }}</label>
          <!-- <select-text :items="select.wards" :id.sync="data.areaId" :error="errors.areaId.error" /> -->
          <vue-single-select
            placeholder
            v-model="ward"
            :options="select.wards"
            option-label="value"
            :classes="{
              input: 'search-input',
              wrapper: 'single-select-wrapper',
              icons: 'icons glyphicon',
              required: 'required'
            }"
          ></vue-single-select>
        </v-col>
      </v-row>
      <v-divider class="mb-0"></v-divider>
      <v-row>
        <v-col sm="8">
          <v-tabs v-model="tab" class="pl-0">
            <v-tab class="text-center">{{ $t("VIETNAMESE") }}</v-tab>
            <v-tab class="text-center">{{ $t("ENGLISH") }}</v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row v-if="data.i18ns && data.i18ns.find(x => x.lang == langTab)">
        <v-col sm="6" class="py-2">
          <label class="label-input">{{ $t("HOTEL_NAME") }} *</label>
          <input-text
            maxlength="255"
            :model.sync="data.i18ns.find(x => x.lang == langTab).name"
            :error="tab == 0 ? errors.nameVi.error : errors.nameEn.error"
          />
        </v-col>
        <v-col sm="6" class="py-2">
          <label class="label-input">{{ $t("ADDRESS") }} *</label>
          <input-text
            maxlength="255"
            :model.sync="data.i18ns.find(x => x.lang == langTab).address"
            :error="tab == 0 ? errors.addressVi.error : errors.addressEn.error"
          />
        </v-col>
        <v-col sm="12" class="py-2 mb-4">
          <label class="label-input">{{ $t("DESCRIPTION_INFO") }}</label>
          <input-textarea
                    :rows="6"
                   :model.sync="data.i18ns.find(x => x.lang == langTab).description"
                  />
          <!-- <vue-editor v-model="data.i18ns.find(x => x.lang == langTab).description"></vue-editor> -->
        </v-col>
      </v-row>
      <v-divider class="mb-2"></v-divider>
      <v-subheader class="p-0">{{ $t("MAP_LOCATION") }}</v-subheader>
      <v-row>
        <v-col sm="6" class="py-2">
          <label class="label-input">{{ $t("LONGITUDE") }} *</label>
          <input-text :regex="REGEX_DISTANCE" :model.sync="data.lat" :error="errors.lat.error" />
        </v-col>
        <v-col sm="6" class="py-2">
          <label class="label-input">{{ $t("LATITUDE") }} *</label>
          <input-text :regex="REGEX_DISTANCE" :model.sync="data.lng" :error="errors.lng.error" />
        </v-col>
        <v-col sm="12" class="py-2">
          <google-map v-if="mapParams" :params.sync="mapParams" :zoom.sync="data.zoom" />
        </v-col>
      </v-row>
    </div>
    <upload-dialog
      :logo="logo"
      :isChooseOneOnly="true"
      :uploadDialog="uploadDialog"
      :uploadedFiles="uploadedFiles"
      @uploadTargetImage="uploadTargetImage"
      ref="uploadComponent"
    >
      <div slot="header" class="tab-header">
        <label class="tab-title">{{ $t("LIBRARY") }}</label>
      </div>
    </upload-dialog>
  </div>
</template>
<script>
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import UploadDialog from "@/components/Utils/UploadDialog.vue";
import GoogleMap from "@/components/Utils/GoogleMap.vue";
import { upload } from "@/_services/UploadFile/file-upload.fake.service"; // fake service
import { registerInfoService } from "@/_services/GeneralInfomation/register-infomation.service.js";
import { VueEditor } from "vue2-editor";
import { systemService } from "@/_services/system-data.service.js";
import {
  _validateFormI18n,
  _storedUserInfo,
  _alert,
  _resetErrorState
} from "@/_helpers/function.js";
import VueSingleSelect from "vue-single-select";
import {
  REGEX_PHONE,
  REGEX_EMAIL,
  REGEX_ENTERPRISE_CODE,
  REGEX_NUMBER,
  REGEX_DISTANCE
} from "@/_helpers/constant.js";
import { RI_ERROR } from "@/_helpers/config.js";
import { setTimeout } from "timers";
import Textarea from "@/components/Utils/Textarea.vue";
export default {
  components: {
    "upload-dialog": UploadDialog,
    "input-text": Input,
    "select-text": Select,
    "google-map": GoogleMap,
    VueSingleSelect,
    VueEditor,
    "input-textarea": Textarea
  },
  created() {
    this.initialize();
    _resetErrorState(this.errors);
    this.select.stars = [
      { id: 0, value: this.lang == "vi" ? "Chưa xếp hạng" : "No rank" },
      { id: 1, value: this.lang == "vi" ? "1 sao" : "1 star" },
      { id: 2, value: this.lang == "vi" ? "2 sao" : "2 stars" },
      { id: 3, value: this.lang == "vi" ? "3 sao" : "3 stars" },
      { id: 4, value: this.lang == "vi" ? "4 sao" : "4 stars" },
      { id: 5, value: this.lang == "vi" ? "5 sao" : "5 stars" }
    ];
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='0']")
      .classList.add("v-tab--active");
  },
  data() {
    return {
      data: [],
      errors: RI_ERROR,
      uploadDialog: false,
      uploadedFiles: [],
      tab: null,
      lang: this.$i18n.locale,
      locations: [],
      country: null,
      city: null,
      district: null,
      ward: null,
      select: {
        hotelTypes: [],
        stars: [],
        countries: [],
        cities: [],
        districts: [],
        wards: []
      },
      mapParams: null,
      logo: JSON.parse(localStorage.getItem("currentUser")).hotel
        ? JSON.parse(localStorage.getItem("currentUser")).hotel.logo
        : null
    };
  },
  computed: {
    REGEX_ENTERPRISE_CODE() {
      return REGEX_ENTERPRISE_CODE;
    },
    REGEX_PHONE() {
      return REGEX_PHONE;
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_DISTANCE() {
      return REGEX_DISTANCE;
    },
    langTab() {
      return this.tab == 0 ? "vi" : "en";
    }
  },
  watch: {
    mapParams: {
      handler(value) {
        this.data.lat = value.lat;
        this.data.lng = value.lng;
      },
      deep: true
    },
    uploadedFiles() {
      return this.$store.state.imageGallary;
    },
    country(value) {
      if (!value) {
        this.city = null;
        this.data.countryId = null;
        this.select.cities = [];
        return false;
      }
      value.value = this.select.countries.find(x => x.id == value.id).value;
      this.data.countryId = value.id;
      this.select.cities = this.locations
        .filter(x => x.parent == value.id)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.lang).name
          };
        });
    },
    city(value) {
      if (!value) {
        this.data.cityId = null;
        this.select.districts = [];
        this.select.wards = [];
        this.district = null;
        this.ward = null;
        return false;
      }
      value.value = this.select.cities.find(x => x.id == value.id).value;
      this.data.cityId = value.id;

      this.select.districts = this.locations
        .filter(x => x.parent == value.id)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.lang).name
          };
        });
      this.select.wards = this.locations
        .filter(x => x.locType == -1 && x.parent == value.id)
        .map(x => {
          return {
            id: x.id,
            value: x.i18ns.find(x => x.lang == this.lang).name
          };
        });
    },
    district(value) {
      if (!value) {
        this.data.locId = null;
        return false;
      }
      value.value = this.select.districts.find(x => x.id == value.id).value;
      this.data.locId = value.id;
    },
    ward(value) {
      if (!value) {
        this.data.areaId = 0;
        return false;
      }
      if (!this.select.wards.find(x => x.id == value.id)) {
        this.ward = null;
        return false;
      }
      value.value = this.select.wards.find(x => x.id == value.id).value;
      this.data.areaId = value.id;
    }
  },
  methods: {
    async initialize() {
      await systemService.getHotelTypes().then(res => {
        this.select.hotelTypes = res.data.map(x => {
          return {
            id: x.typeId,
            value: x.i18ns.find(x => x.lang == this.lang)
              ? x.i18ns.find(x => x.lang == this.lang).name
              : ""
          };
        });
      });
      await systemService.getLocations().then(res => {
        this.locations = res.data;
        this.select.countries = res.data
          .filter(x => !x.parent)
          .map(x => {
            return {
              id: x.id,
              value: x.i18ns.find(x => x.lang == this.lang)
                ? x.i18ns.find(x => x.lang == this.lang).name
                : ""
            };
          });
      });
      await registerInfoService.get().then(res => {
        this.data = res.data;
        this.country = {
          id: res.data.countryId,
          value: null
        };
        this.city = {
          id: res.data.cityId,
          value: null
        };
        this.district = {
          id: res.data.locId,
          value: null
        };
        this.ward = {
          id: res.data.areaId,
          value: null
        };
        //mark
        this.data.star = this.data.star || 0;
        this.data.hotelType = this.data.hotelType || 0;
        this.mapParams = {
          lat: this.data.lat,
          lng: this.data.lng
        };
        if (!this.logo) {
          this.data.logo.id = null;
        }
        this.data.logoId = this.data.logo.id;
      });
    },
    upload() {
      this.$refs.uploadComponent.open();
    },
    uploadTargetImage(data) {
      if (data.id === -1) {
        return true;
      }
      this.data.logoId = data[0].id;
      this.data.logo = {
        id: data[0].id,
        imgDetailsUrl: data[0].detail,
        imgFullUrl: data[0].full,
        imgSmalListUrl: data[0].small,
        imgThumbUrl: data[0].thumb,
        url: data[0].img
      };
    },
    async save() {
      let temp = Object.assign({}, this.data);
      temp.nameVi = temp.i18ns.find(x => x.lang == "vi").name;
      temp.nameEn = temp.i18ns.find(x => x.lang == "en").name;
      temp.addressVi = temp.i18ns.find(x => x.lang == "vi").address;
      temp.addressEn = temp.i18ns.find(x => x.lang == "en").address;
      let { isValid, error } = _validateFormI18n(temp, this.errors);
      this.errors = error;
      if (this.errors.nameVi.error || this.errors.addressVi.error) {
        this.tab = 0;
        return false;
      }
      if (this.errors.nameEn.error || this.errors.addressEn.error) {
        this.tab = 1;
        return false;
      }
      if (!isValid) return false;
      let logoUrl = this.data.logo.url;
      delete this.data.logo;
      await registerInfoService.update(this.data).then(res => {
        if (res.responseCode == 0) {
          _storedUserInfo("hotel/logo", logoUrl);
          let currentUser = JSON.parse(localStorage.getItem("currentUser"));
          if (currentUser.hotel) {
            currentUser.hotel.i18ns.find(
              x => x.lang == "vi"
            ).name = this.data.i18ns.find(x => x.lang == "vi").name;
            currentUser.hotel.i18ns.find(
              x => x.lang == "en"
            ).name = this.data.i18ns.find(x => x.lang == "en").name;
          }
          localStorage.setItem("currentUser", JSON.stringify(currentUser));
        }
        _alert(res, this.$t(res.data));
      });
    }
  }
};
</script>
